import { useSelector } from 'react-redux';
import { setAllTickets as setAllT } from './ticket-type.slice';

const getMaxSelectedObjects = ({ name, max_per_sale, category_id }) => ({
  ticketType: name,
  quantity: max_per_sale,
  category_id,
});

const getCategoryTicketType = ({
  name = '',
  max_price = 0,
  ticket_type_id,
}) => ({
  ticketType: `${ticket_type_id}`,
  price: max_price,
  label: name,
});

const upsertCategory = (ticketType, categories = []) => {
  const currentCategory = categories.find(
    (category) => category.category === ticketType.category_id,
  );
  if (currentCategory) {
    const otherCategories = categories.filter(
      (category) => category.category !== ticketType.category_id,
    );
    currentCategory.ticketTypes = [
      ...currentCategory.ticketTypes,
      getCategoryTicketType(ticketType),
    ];
    return [...otherCategories, currentCategory];
  }
  return [
    ...categories,
    {
      category: ticketType.category_id,
      ticketTypes: [getCategoryTicketType(ticketType)],
    },
  ];
};

export const extractData = (data) => {
  let formatedResponse = [];
  let maxSelectedObjects = [];
  let categories = [];
  let maxSelectedTicket = 10;
  let availableCategories = [];
  let prices = [];
  if (data) {
    formatedResponse = data.map((ticketType) => {
      categories = upsertCategory(ticketType, categories);
      prices = [...prices, ticketType.max_price];
      return {
        id: ticketType.category_name
          ? `${ticketType.category_name}-${ticketType.name}`
          : ticketType.ticket_type_id,
        ...ticketType,
      };
    });
    maxSelectedObjects = data.map((ticketType) => {
      return getMaxSelectedObjects(ticketType);
    });
    availableCategories = data.map(({ category_name }) => {
      return category_name;
    });
  }

  categories = categories.map((category) => {
    if (category.ticketTypes && category.ticketTypes.length === 1) {
      return {
        category: category.category,
        price: category.ticketTypes[0].price,
      };
    }
    return category;
  });

  return {
    ticketTypes: formatedResponse,
    categories,
    maxSelectedObjects,
    maxSelectedTicket,
    availableCategories,
    prices,
  };
};

export default function useTicketTypes() {
  const data = useSelector((state) =>
    state.ticketTypes.ids.map((id) => state.ticketTypes.entities[id]),
  );

  const {
    ticketTypes,
    categories,
    maxSelectedObjects,
    maxSelectedTicket,
    availableCategories,
    prices,
  } = extractData(data);

  const getByName = (name) =>
    ticketTypes.find((ticketType) => ticketType.name === name);

  const getByTicketTypeID = (ticketTypeID) =>
    ticketTypes.find(
      (ticketType) => ticketType.ticket_type_id === ticketTypeID,
    );

  const getByCategoryID = (categoryID) =>
    ticketTypes.find((ticketType) => ticketType.category_id === categoryID);

  const setAllTickets = (tickets) => {
    dispatch(setAllT(tickets));
  };

  return {
    data,
    ticketTypes,
    categories,
    maxSelectedObjects,
    maxSelectedTicket,
    availableCategories,
    prices,
    getByName,
    getByTicketTypeID,
    getByCategoryID,
    setAllTickets,
  };
}
